// So o hexagono do logoHeader, para a faixa da marca na sidebar, onde o
// seletor de modulo divide o espaco com ela (#484909).
export const logoMarca = ['63 69', `
<title>Panorama Sistemas</title>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 69">
<path fill="#fff" d="M56.66,13,36.93,1.54a11.4,11.4,0,0,0-11.46,0L5.73,13A11.52,11.52,0,0,0,0,23V45.84a11.52,11.52,0,0,0,5.73,10L25.47,67.25a11.4,11.4,0,0,0,11.46,0L56.66,55.81a11.52,11.52,0,0,0,5.73-10V23A11.52,11.52,0,0,0,56.66,13Zm-11,25.48L32.82,45.9a.73.73,0,0,0-.36.63l0,7.52a.74.74,0,0,1-1.11.64L16.77,46.27a.73.73,0,0,1-.37-.64V39.1a.76.76,0,0,1,.37-.65l13.12-7.53a.74.74,0,0,0,0-1.29L17,22.49a.74.74,0,0,1,0-1.29l12.23-7.1a.73.73,0,0,1,.73,0l15.33,8.47a1.48,1.48,0,0,1,.76,1.3v14A.75.75,0,0,1,45.63,38.46Z" />
</svg>
`]
